export const MY_SERVICES_ROUTE = '/services';

export const CREATE_SERVICE_ROUTE = `${MY_SERVICES_ROUTE}/create-service`;

export const EDIT_SERVICE_ROUTE = `${MY_SERVICES_ROUTE}/edit-service/:serviceId`;

export const getEditServiceRoute = (serviceId: string) =>
  EDIT_SERVICE_ROUTE.replace(':serviceId', serviceId);
